/* eslint-disable */
import _ from 'lodash'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)

//Vue.axios.defaults.baseURL = 'https://madai-server.herokuapp.com/api/madai/v0/'
// Vue.axios.defaults.baseURL = 'http://localhost:3000/api/madai/v0/'
//Vue.axios.defaults.baseURL = 'https://api.madai.mx/api/madai/v0/'
let axiosBaseUrl = 'https://api.madai.mx/'
//let axiosBaseUrl = 'http://localhost:8000/'
let axiosApi = 'api/madai/v0/'
Vue.axios.defaults.baseURL = axiosBaseUrl + axiosApi //'http://127.0.0.1:8000/api/madai/v0/'
Vue.axios.defaults.headers.common['Authorization'] = `${localStorage.getItem('token')}`

let wishlistLS = obtenerLocalStorageWishlist()

function obtenerLocalStorageWishlist () {
  let wishlist = localStorage.getItem('wishlist')
  if (wishlist !== null) {
    wishlist = JSON.parse(wishlist)
  } else {
    wishlist = []
    localStorage.setItem('wishlist', JSON.stringify(wishlist))
  }
  return wishlist
}

const wishlist = {
  total () {
    return wishlistLS.length || 0
  },
  agregar (item) {
    if (wishlist.existe(item.cve)) {
      item.wishlist = false
      wishlistLS = wishlistLS.filter(itm => itm.cve !== item.cve)
    } else {
      item.wishlist = true
      wishlistLS.push(item)
    }
    localStorage.setItem('wishlist', JSON.stringify(wishlistLS))
  },
  borrarTodo () {
    wishlistLS = []
    localStorage.removeItem('wishlist')
  },
  eliminar (clave) {
    wishlistLS = wishlistLS.filter(itm => itm.cve !== clave)
    localStorage.setItem('wishlist', JSON.stringify(wishlistLS))
  },
  existe (clave) {
    wishlistLS = obtenerLocalStorageWishlist()
    return wishlistLS.findIndex(itm => itm.cve === clave) !== -1
  },
  obtenerTodo () {
    return wishlistLS
  }
}

const api = {
  async busqueda () {
    try {
      let resp = await Vue.axios.get('busqueda')
      return resp.data
    } catch (err) {
      return Promise.reject(new Error(obtenerError(err)))
    }
  },
  async master () {
    try {
      let resp = await Vue.axios.get('master')
      resp.data.PROMOCIONES = JSON.parse(resp.data.PROMOCIONES)
      return resp.data
    } catch (err) {
      return Promise.reject(new Error(obtenerError(err)))
    }
  },
  catalogo: {
    async detallesArgollas (id = 0) {
      try {
        let resp = await Vue.axios.get('argollas/' + id)
        return Object.assign(resp.data, { wishlist: wishlist.existe(resp.data.cve), cat: 'argolla' })
      } catch (err) {
        return Promise.reject(new Error(obtenerError(err)))
      }
    },
    async argollas () {
      try {
        let resp = await Vue.axios.get('argollas')
        return resp.data.map(itm => Object.assign(itm, { wishlist: wishlist.existe(itm.clave), cat: 'argolla' }))
      } catch (err) {
        return Promise.reject(new Error(obtenerError(err)))
      }
    },
    async detallesChurumbela (id = 0) {
      try {
        let resp = await Vue.axios.get('churumbelas/' + id)
        return Object.assign(resp.data, { wishlist: wishlist.existe(resp.data.cve), cat: 'churumbela' })
      } catch (err) {
        return Promise.reject(new Error(obtenerError(err)))
      }
    },
    async churumbelas () {
      try {
        let resp = await Vue.axios.get('churumbelas')
        return resp.data.map(itm => Object.assign(itm, { wishlist: wishlist.existe(itm.clave), cat: 'churumbela' }))
      } catch (err) {
        return Promise.reject(new Error(obtenerError(err)))
      }
    },
    async detallesCompromiso (id = 0) {
      try {
        if (id !== 0 && id !== '') {
          let resp = await Vue.axios.get('compromiso/' + id)
          return Object.assign(resp.data, { wishlist: wishlist.existe(resp.data.cve), cat: 'compromiso' })
        }
      } catch (err) {
        return Promise.reject(new Error(obtenerError(err)))
      }
    },
    async zirconia () {
      try {
        let resp = await Vue.axios.get('zirconia')
        resp.data = resp.data.map(itm => {
          itm.img_ext = itm.image || ''
          itm.image = itm.cover
          itm.cat = 'zirconia'
          return itm
        })
        return resp.data.map(itm => Object.assign(itm, { wishlist: wishlist.existe(itm.clave), cat: 'compromiso' }))
      } catch (err) {
        return Promise.reject(new Error(obtenerError(err)))
      }
    },
    async detallesZirconia (id = 0) {
      try {
        let resp = await Vue.axios.get('zirconia/' + id)
        resp.data = Object.assign(resp.data, { img_ext: resp.data.image || '', cat: 'circonia' })
        return Object.assign(resp.data, { wishlist: wishlist.existe(resp.data.cve) })
      } catch (err) {
        return Promise.reject(new Error(obtenerError(err)))
      }
    },
    async compromiso () {
      try {
        let resp = await Vue.axios.get('compromiso')
        return resp.data.map(itm => {
          itm.c_cut = itm.c_cut || ''
          itm.decorative1 = itm.decorative1 || ''
          itm.decorative2 = itm.decorative2 || ''
          itm.specification = itm.specification || ''
          itm.color = itm.color || ''
          itm.m_weight = itm.m_weight || 'N/A'
          itm.wishlist = wishlist.existe(itm.cve)
          itm.cat = 'compromiso'
          return itm
        })
      } catch (err) {
        return Promise.reject(new Error(obtenerError(err)))
      }
    },
    async detallesDiamante (id = 0) {
      try {
        let resp = await Vue.axios.get('diamante/' + id)
        return Object.assign(resp.data, { wishlist: wishlist.existe(resp.data.cve), cat: 'diamante', DiamondImage: resp.data.DiamondImage.includes('NULL') ? '' : resp.data.DiamondImage })
      } catch (err) {
        return Promise.reject(new Error(obtenerError(err)))
      }
    },
    async diamantes () {
      try {
        let resp = await Vue.axios.get('diamantes')
        return _.orderBy(resp.data.map(itm => Object.assign(itm, { cat: 'diamante', DiamondImage: itm.DiamondImage.includes('NULL') ? '' : itm.DiamondImage })), ['Price'], ['asc'])
      } catch (err) {
        return Promise.reject(new Error(obtenerError(err)))
      }
    },
    async detallesPromesa (id = 0) {
      try {
        let resp = await Vue.axios.get('promesa/' + id)
        return Object.assign(resp.data, { wishlist: wishlist.existe(resp.data.cve), cat: 'promesa' })
      } catch (err) {
        return Promise.reject(new Error(obtenerError(err)))
      }
    },
    async promesa () {
      try {
        let resp = await Vue.axios.get('promesa')
        return resp.data.map(itm => Object.assign(itm, { wishlist: wishlist.existe(itm.clave), cat: 'promesa' }))
      } catch (err) {
        return Promise.reject(new Error(obtenerError(err)))
      }
    },
    async detallesCadenas (id = 0) {
      try {
        let resp = await Vue.axios.get('cadenas/' + id)
        resp.data.image = resp.data.cover
        return Object.assign(resp.data, { wishlist: wishlist.existe(resp.data.cve), cat: 'cadenas' })
      } catch (err) {
        return Promise.reject(new Error(obtenerError(err)))
      }
    },
    async cadenas () {
      try {
        let resp = await Vue.axios.get('cadenas')
        resp.data = resp.data.map(itm => {
          itm.image = itm.cover
          return itm
        })
        return resp.data.map(itm => Object.assign(itm, { wishlist: wishlist.existe(itm.clave), cat: 'cadenas' }))
      } catch (err) {
        return Promise.reject(new Error(obtenerError(err)))
      }
    },
    async detallesAretes (id = 0) {
      try {
        let resp = await Vue.axios.get('aretes/' + id)
        return Object.assign(resp.data, { img_ext: resp.data.images, image: resp.data.cover, wishlist: wishlist.existe(resp.data.cve), cat: 'aretes' })
      } catch (err) {
        return Promise.reject(new Error(obtenerError(err)))
      }
    },
    async aretes () {
      try {
        let resp = await Vue.axios.get('aretes')
        resp.data = resp.data.map(itm => {
          itm.image = itm.cover
          itm.img_ext = itm.images
          return itm
        })
        return resp.data.map(itm => Object.assign(itm, { wishlist: wishlist.existe(itm.clave), cat: 'aretes' }))
      } catch (err) {
        return Promise.reject(new Error(obtenerError(err)))
      }
    },
    async detallesDijes (id = 0) {
      try {
        let resp = await Vue.axios.get('dijes/' + id)
        return Object.assign(resp.data, { img_ext: resp.data.images, image: resp.data.cover, wishlist: wishlist.existe(resp.data.cve), cat: 'dijes' })
      } catch (err) {
        return Promise.reject(new Error(obtenerError(err)))
      }
    },
    async dijes () {
      try {
        let resp = await Vue.axios.get('dijes')
        resp.data = resp.data.map(itm => {
          itm.image = itm.cover
          itm.img_ext = itm.images
          return itm
        })
        return resp.data.map(itm => Object.assign(itm, { wishlist: wishlist.existe(itm.clave), cat: 'dijes' }))
      } catch (err) {
        return Promise.reject(new Error(obtenerError(err)))
      }
    },
    async detallesPulsera (id = 0) {
      try {
        let resp = await Vue.axios.get('pulso/' + id)
        return Object.assign(resp.data, { img_ext: resp.data.images, image: resp.data.cover, wishlist: wishlist.existe(resp.data.cve), cat: 'pulso' })
      } catch (err) {
        return Promise.reject(new Error(obtenerError(err)))
      }
    },
    async pulseras () {
      try {
        let resp = await Vue.axios.get('pulso')
        resp.data = resp.data.map(itm => {
          itm.image = itm.cover
          itm.img_ext = itm.images
          return itm
        })
        return resp.data.map(itm => Object.assign(itm, { wishlist: wishlist.existe(itm.clave), cat: 'pulso' }))
      } catch (err) {
        return Promise.reject(new Error(obtenerError(err)))
      }
    },
    async detallesConjunto (id = 0) {
      try {
        let resp = await Vue.axios.get('conjuntos/' + id)
        return Object.assign(resp.data, { img_ext: resp.data.image, image: resp.data.cover, wishlist: wishlist.existe(resp.data.cve), cat: 'conjuntos' })
      } catch (err) {
        return Promise.reject(new Error(obtenerError(err)))
      }
    },
    async conjuntos () {
      try {
        let resp = await Vue.axios.get('conjuntos')
        resp.data = resp.data.map(itm => {
          itm.image = itm.cover
          itm.img_ext = itm.image
          return itm
        })
        return resp.data.map(itm => Object.assign(itm, { wishlist: wishlist.existe(itm.clave), cat: 'conjuntos' }))
      } catch (err) {
        return Promise.reject(new Error(obtenerError(err)))
      }
    },
    restarStock (carrito) {
      try {
        carrito.forEach(async itm => {
          if (itm.idar_articles) {
            await Vue.axios.get(`aretes/${itm.idar_articles}/comprado`)
          } else if (itm.id_chain) {
            await Vue.axios.get(`cadenas/${itm.id_chain}/comprado`)
          } else if (itm.idpul_articles) {
            await Vue.axios.get(`pulso/${itm.idpul_articles}/comprado`)
          } else if (itm.ida_zirconia) {
            await Vue.axios.get(`zirconia/${itm.ida_zirconia}/comprado`)
          } else if (itm.idcj_articles) {
            await Vue.axios.get(`conjuntos/${itm.idcj_articles}/comprado`)
          }
        })
      } catch (err) {
        return Promise.reject(new Error(obtenerError(err)))
      }
    }
  },
  usuario: {
    async auth (email, password, nuevo) {
      try {
        let resp = await Vue.axios.post('auth', { email, password })
        let { usuario, token } = resp.data
        Vue.axios.defaults.headers.common['Authorization'] = `${token}`

        if (nuevo) {
          await Vue.axios.post('envio', { idorder: '', idusuario: usuario.iduser, nombre: '', direccion1: '', direccion2: '', estado: '', ciudad: '', cp: '', email: '', telefono: '' })
          await Vue.axios.post('facturacion', { idorder: '', idusuario: usuario.iduser, nombre: '', direccion1: '', direccion2: '', estado: '', ciudad: '', cp: '', email: '', telefono: '' })
        }

        resp = await Vue.axios.get('envio/' + usuario.iduser)
        let envio = resp.data
        resp = await Vue.axios.get('facturacion/' + usuario.iduser)
        let facturacion = resp.data
        localStorage.setItem('token', token)
        return { usuario, token, envio, facturacion }
      } catch (err) {
        return Promise.reject(new Error(obtenerError(err)))
      }
    },
    async guardar (data) {
      try {
        let resp = await Vue.axios.put('usuario', data)
        return resp.data
      } catch (err) {
        return Promise.reject(new Error(obtenerError(err)))
      }
    },
    async nuevo (data) {
      try {
        let resp = await Vue.axios.post('usuario', data)
        return resp.data
      } catch (err) {
        return Promise.reject(new Error(obtenerError(err)))
      }
    },
    cerrar () {
      Vue.axios.defaults.headers.common['Authorization'] = ``
      localStorage.removeItem('token')
    }
  },
  envio: {
    async sendMail (correo, token) {
      try {
        let resp = await Vue.axios.post('send-mail', correo)
        return resp.data
      } catch (err) {
        return Promise.reject(new Error(obtenerError(err)))
      }
    },
    async pcSendMail (correo, token) {
      try {
        let resp = await Vue.axios.post('pc-send-mail', correo)
        return resp.data
      } catch (err) {
        return Promise.reject(new Error(obtenerError(err)))
      }
    },
    async getNewId(){
      try{
        let resp = await Vue.axios.get('newid')
        return resp.data
      } catch (err) {
        return Promise.reject(new Error(obtenerError(err)))
      }
    },
    async uploadImage(data){
      try {
        let resp = await Vue.axios.post('load-imagenes', data)
        return resp.data
      } catch (err) {
        return Promise.reject(new Error(obtenerError(err)))
      }
    },
    async nuevo (data) {
      try {
        let resp = await Vue.axios.post('envio', data)
        return resp.data
      } catch (err) {
        return Promise.reject(new Error(obtenerError(err)))
      }
    },
    async guardar (data) {
      try {
        let resp = await Vue.axios.put('envio', data)
        return resp.data
      } catch (err) {
        return Promise.reject(new Error(obtenerError(err)))
      }
    }
  },
  facturacion: {
    async nuevo (data) {
      try {
        let resp = await Vue.axios.post('facturacion', data)
        return resp.data
      } catch (err) {
        return Promise.reject(new Error(obtenerError(err)))
      }
    },
    async guardar (data) {
      try {
        let resp = await Vue.axios.put('facturacion', data)
        return resp.data
      } catch (err) {
        return Promise.reject(new Error(obtenerError(err)))
      }
    }
  },
  payworks: {
    async pagar (detalles) {
      try {
        let resp = await Vue.axios.post('payworks/pagar', detalles)
        return resp.data
      } catch (err) {
        return Promise.reject(new Error(obtenerError(err)))
      }
    }
  },
  venta: {
    async registrar (venta) {
      try {
        let resp = await Vue.axios.post('venta', { venta })
        return resp.data
      } catch (err) {
        return Promise.reject(new Error(obtenerError(err)))
      }
    }
  },
  cupones: {
    async validar (codigo) {
      try {
        let resp = await Vue.axios.get(`cupones/validar/${codigo}`)
        return resp.data
      } catch (err) {
        return Promise.reject(new Error(obtenerError(err)))
      }
    },
    async usar (codigo) {
      try {
        let resp = await Vue.axios.get(`cupones/${codigo}`)
        return resp.data.actualizado
      } catch (err) {
        return Promise.reject(new Error(obtenerError(err)))
      }
    }
  }
}

function obtenerError (err) {
  console.log(err)
  if (err.response && err.response.data && err.response.data.Message) {
    if (err.response.data.Message === 'Authorization has been denied for this request.') {
      window.localStorage.removeItem('token')
      window.location = '/'
    } else {
      return err.response.data.Message
    }
  } else {
    // window.localStorage.removeItem('token')
    // window.location = '/'
    return 'Error al intentar conectarse al servidor.'
  }
}

export default {
  install: (Vue, options) => {
    // if (localStorage.getItem('token')) {
    //   Vue.axios.defaults.headers.common['Authorization'] = `${localStorage.getItem('token')}`
    // }

    Vue.$api = Vue.prototype.$api = api
    Vue.$wishlist = Vue.prototype.$wishlist = wishlist
  }
}
